// extracted by mini-css-extract-plugin
module.exports = {"button":"button___1Dr-l","buttonText":"buttonText___2NzyE","arrow":"arrow___2o-9A"};